// extracted by mini-css-extract-plugin
export var brand = "_6d-9";
export var compact = "_6d-6";
export var extraSmall = "_6d-7";
export var icon = "_6d-0";
export var large = "_6d-4";
export var light = "_6d-1";
export var medium = "_6d-5";
export var outline = "_6d-b";
export var primaryDark = "_6d-a";
export var primaryLight = "_6d-8";
export var primaryModern = "_6d-c";
export var success = "_6d-2";
export var successSolid = "_6d-3";